import { useParams } from 'react-router-dom';

import { ContentPage as ContentPageFeature } from '../../../features/content/content-page';
import { ContentType } from '../../../features/content/generated/content';

const isContentType = (value: string): value is ContentType => {
  return value === ContentType.Article;
};

const ContentPage = () => {
  const { id, type } = useParams();
  if (!id) throw new Error('Missing content id');
  if (!type) throw new Error('Missing content type');
  if (!isContentType(type)) throw new Error('Unknown content type');

  return <ContentPageFeature id={id} type={type} />;
};

export { ContentPage };
